import { ChangeDetectionStrategy, Component, ContentChild, Input } from '@angular/core'
import { AbstractColumn } from '@shared/components/tables/abstract-column'
import { MatFormFieldControl } from '@angular/material/form-field'

@Component({
  selector: 'lin-table-header-control',
  templateUrl: './table-header-control.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableHeaderControlComponent extends AbstractColumn {
  @Input() sticky: boolean
  @Input() stickyEnd: boolean

  @ContentChild(MatFormFieldControl, { static: true }) control: MatFormFieldControl<any>
}
